import {BrowserRouter, Routes, Route} from 'react-router'

import DashboardSupplierScreen from '~/react/screens/DashboardScreen/Supplier'
import SupplierCustomersScreen from '~/react/screens/SupplierCustomersScreen'
import SupplierCustomerScreen from '~/react/screens/SupplierCustomerScreen/ParamWrapper'

export default function Router(props) {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/dashboard"
          element={<DashboardSupplierScreen {...props} />}
        />
        <Route
          path="/setup_templates/*"
          element={<DashboardSupplierScreen {...props} />}
        />
        <Route
          path="/customers"
          element={<SupplierCustomersScreen {...props} />}
        />
        <Route
          path="/customers/:customerId"
          element={<SupplierCustomerScreen {...props} />}
        />
        <Route
          path="/customers/transition_to_marmalade/*"
          element={<SupplierCustomersScreen {...props} />}
        />
        <Route
          path="/connect_payout_account/*"
          element={<DashboardSupplierScreen {...props} />}
        />
        <Route
          path="/connect_expense_account/*"
          element={<DashboardSupplierScreen {...props} />}
        />
      </Routes>
    </BrowserRouter>
  )
}
